/* Accessibility improvements are scoped to theme-owned controls, never app internals. */
(function () {
  'use strict';
  function initMenu() {
    var menu = document.getElementById('navMobile'), burger = document.getElementById('navBurger');
    if (!menu || !burger) return;
    function sync() {
      var open = menu.classList.contains('open') && window.innerWidth < 1280;
      menu.inert = !open;
      menu.setAttribute('aria-hidden', String(!open));
      burger.setAttribute('aria-expanded', String(open));
    }
    new MutationObserver(sync).observe(menu, {attributes: true, attributeFilter: ['class']});
    window.addEventListener('resize', sync, {passive: true});
    document.addEventListener('keydown', function (event) {
      if (menu.inert) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        if (typeof window.closeMobileMenu === 'function') window.closeMobileMenu();
        sync(); burger.focus(); return;
      }
      if (event.key !== 'Tab') return;
      var links = Array.from(menu.querySelectorAll('a[href],button')).filter(function (el) { return !el.disabled && el.getClientRects().length; });
      if (!links.length) return;
      var first = links[0], last = links[links.length - 1], active = document.activeElement;
      if (event.shiftKey && (active === first || active === burger)) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && active === last) { event.preventDefault(); burger.focus(); }
    });
    sync();
  }
  function initCarouselState() {
    document.querySelectorAll('.sf-dots, .sp-mobile-dots').forEach(function (group) {
      function sync() {
        group.querySelectorAll('button').forEach(function (button) {
          var active = button.classList.contains('sf-dot-active') || button.classList.contains('sp-mobile-dot-active');
          if (active) button.setAttribute('aria-current', 'true');
          else button.removeAttribute('aria-current');
        });
      }
      new MutationObserver(sync).observe(group, {subtree: true, attributes: true, attributeFilter: ['class']});
      sync();
    });
  }
  function init() { initMenu(); initCarouselState(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
